// @flow

import React from 'react';
import styled from 'styled-components';

import type { OtherImageFragment } from 'graphql-types';

const RealImage = styled.img`
  width: 100%;
  pointer-events: none;
`;

const OtherImageLoader = (props: { visible: boolean, alt?: string, image: OtherImageFragment }) => {
  const { visible, image, alt = '' } = props;
  return visible ? <RealImage src={image.publicURL} alt={alt} role={alt ? null : 'presentation'} /> : null;
};

export default OtherImageLoader;
